// Camada central de autorização no frontend (espelha permissions_meta.py no backend).
// Suporta permissões legadas (view_inventory) e granulares (inventory.vehicles.view) ao mesmo tempo.
export const LEGACY_FALLBACK = {
  'inventory.vehicles.view': ['view_inventory'],
  'inventory.vehicles.create': ['edit_inventory'],
  'inventory.vehicles.edit': ['edit_inventory'],
  'inventory.vehicles.delete': ['edit_inventory', 'delete_records'],
  'inventory.vehicle_cost.view': ['view_vehicle_costs'],
  'inventory.vehicle_cost.edit': ['view_vehicle_costs', 'edit_inventory'],
  'sales.deals.view': ['view_deals'],
  'sales.deals.edit': ['edit_deals'],
  'sales.deals.approve': ['approve_deals'],
  'sales.deals.gross_profit.view': ['view_gross_profit'],
  'crm.leads.view': ['view_crm'],
  'crm.leads.create': ['view_crm'],
  'crm.leads.edit': ['view_crm'],
  'crm.leads.assign': ['assign_salesperson'],
  'crm.leads.reassign': ['reassign_customer'],
  'service.ro.view': ['view_service'],
  'service.ro.create': ['create_ro'],
  'service.ro.edit': ['create_ro'],
  'customers.view': ['view_customers'],
  'reports.view': ['view_reports'],
  'admin.users.manage': ['manage_users'],
  'admin.permissions.manage': ['manage_users'],
};

const FULL_ACCESS_ROLES = ['Owner', 'Administrator'];

export const can = (user, key) => {
  if (!key) return true;
  if (FULL_ACCESS_ROLES.includes(user?.role)) return true;
  const perms = user?.permissions;
  if (!perms) return true; // sem lista carregada: mantém o comportamento atual (não bloqueia)
  if (perms.includes(key)) return true;
  return (LEGACY_FALLBACK[key] || []).some((legacy) => perms.includes(legacy));
};
